import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../utils/LoadingSpinner";

function AuthHelper(props: React.PropsWithChildren) {
  const {
    getAccessTokenSilently,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
  } = useAuth0();
  const [isTokenReady, setIsTokenReady] = useState(false);

  const authAudience = process.env.REACT_APP_AUTH0_AUDIENCE;
  const authScope = ["openid", "profile", "email", "offline_access"];

  if (authAudience) {
    authScope.push("full_access");
  }

  useEffect(() => {
    let isActive = true;

    async function initializeToken() {
      if (isLoading) {
        return;
      }

      if (!isAuthenticated) {
        localStorage.removeItem("token");
        if (isActive) {
          setIsTokenReady(true);
        }
        return;
      }

      try {
        const token = await getAccessTokenSilently();
        if (!token) {
          return;
        }

        localStorage.setItem("token", token);

        if (isActive) {
          setIsTokenReady(true);
        }
      } catch (error: any) {
        if (
          error?.error === "consent_required" ||
          error?.error === "interaction_required" ||
          error?.error === "login_required"
        ) {
          await loginWithRedirect({
            appState: {
              returnTo:
                window.location.pathname +
                window.location.search +
                window.location.hash,
            },
            authorizationParams: {
              ...(authAudience ? { audience: authAudience } : {}),
              scope: authScope.join(" "),
            },
          });
          return;
        }

        console.error(error);
      }
    }

    if (!isAuthenticated) {
      setIsTokenReady(false);
    }

    initializeToken();

    return () => {
      isActive = false;
    };
  }, [
    authAudience,
    getAccessTokenSilently,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
  ]);

  if (isLoading || (isAuthenticated && !isTokenReady)) {
    return <LoadingSpinner />;
  }

  return <>{props.children}</>;
}

export default AuthHelper;
